import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Pages/Home/Home';
import Register from './Pages/Auth/Register';
import Login from './Pages/Auth/Login';
import RequiredAuth from "./MiddleWay/RequiredAuth"
import Contact from './Component/Contact/Contact';
import About from './Component/About/About';
import Gallery from './Component/Gallery/Gallery';
import Classes from './Component/Classes/Classes';
import Successfully from './Component/Successfully/Successfully';
import Details from './Pages/Portal/Details/Details';
import DetailEnroll from './Pages/Portal/DetailEnroll/DetailEnroll';
import AddStudent from './Pages/Portal/AddStudent/AddStudent';
import Booking from './Pages/Portal/Booking/Booking';
import PartBookingDate from './Pages/Portal/PartyBooking/PartBookingDate';
import BySlotTime from './Pages/Portal/PartyBooking/BySlotTime/BySlotTime';
import ByBookPackage from './Pages/Portal/PartyBooking/ByBookPackage/ByBookPackage';
import CheckOut from './Pages/Portal/CheckOut/CheckOut';
import Question_1 from './Pages/Portal/Question/Question_1';
import Question_2 from './Pages/Portal/Question/Question_2';
import Question_3 from './Pages/Portal/Question/Question_3';
import ChildQuestion from './Pages/Portal/ChildQuestion/ChildQuestion';
import MembershipCard from './Pages/Portal/MembershipCard/MembershipCard';
import MyAccount from './Pages/Portal/Account/MyAccount';
import ChangePassword from './Pages/Portal/ChangePassword/ChangePassword';
import PartyDetails from './Pages/Portal/PartyBooking/PartyDetails/PartyDetails';
import AddOns from './Pages/Portal/PartyBooking/AddOns/AddOns';
import Summary from './Pages/Portal/PartyBooking/Summary/PartySummary';
import PartySummary from './Pages/Portal/PartyBooking/Summary/PartySummary';
import Warning from './Pages/Portal/PartyBooking/Warning/Warning';
import RenewSubscription from './Pages/Portal/RenewSubscription/RenewSubscription';
import RenewCheckout from './Pages/Portal/RenewSubscription/RenewCheckout';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/about' element={<About/>} />
        <Route path='/gallery' element={<Gallery/>}/>
        <Route path='/register' element={<Register/>} />
        <Route path='/classes' element={<Classes/>} />
        <Route path='/classes/details' element={<Details/>} />

         {/*   for portal or   user dashboard */}
        <Route path='/portal/booking' element={<Booking/>} />
        <Route path='/portal/booking/wizard-question-1' element={<Question_1/>}/>
        <Route path='/portal/booking/wizard-question-2' element={<Question_2/>}/>
        <Route path="/portal/booking/wizard-question-3/:id" element={<Question_3 />}/>
        <Route path='/portal/booking/classes/' element={<Details/>} />
        <Route path='/portal/booking/classes/DetailEnroll/:id' element={<DetailEnroll/>} />
        <Route path='/login' element={<Login/>} /> 
        <Route path='/portal/booking/classes/add-student' element={<RequiredAuth><AddStudent/></RequiredAuth>} />
        <Route path='/portal/booking/classes/childQuestion' element={<RequiredAuth><ChildQuestion/></RequiredAuth>} />
        <Route path='/portal/booking/subscription/membership' element={<RequiredAuth><MembershipCard/></RequiredAuth>}/>
        <Route path='/portal/booking/classes/renew/subscription' element={<RequiredAuth><RenewSubscription/></RequiredAuth>}/>
        <Route path='/portal/booking/party/checkout' element={<RequiredAuth><CheckOut/></RequiredAuth>} />
        <Route path='/portal/booking/classes/renew/subscription/checkout' element={<RequiredAuth><RenewCheckout/></RequiredAuth>} />
        <Route path='/portal/booking/party/party-booking-01-date' element={<PartBookingDate/>}/>
        <Route path='/portal/booking/party/party-booking-02-timeslot' element={<BySlotTime/>} />
        <Route path='/portal/booking/party/party-booking-03-package' element={<ByBookPackage/>} />
        <Route path='/portal/dashboard/account' element={<RequiredAuth><MyAccount/></RequiredAuth>} />
        <Route path='/portal/dashboard/changePassword' element={<RequiredAuth><ChangePassword/></RequiredAuth>} />
        <Route path='/portal/booking/party/add-on' element={<RequiredAuth><AddOns/></RequiredAuth>} />
        <Route path='/portal/booking/party/details' element={<RequiredAuth><PartyDetails/></RequiredAuth>} />
        <Route path='/portal/booking/party/summary' element={<RequiredAuth><PartySummary/></RequiredAuth>} />
         <Route path='/portal/booking/party/warning' element={<RequiredAuth><Warning/></RequiredAuth>} />
        {/*<Route path='/complete' element={<Payment/>}/>*/}
        <Route path='/message-complete' element={<Successfully/>}/> 
      </Routes>

    </div>
  );
}

export default App;
